<div class="entry-content">

  <div class="title" *ngIf="!isMobile">
    <p>
      {{'PRIVATE_POLICY_MODULE.TITLE' | transloco | uppercase}}
    </p>
  </div>

  <div class="box-content">
    <p> TRAVEL MOUSTACHE S.A.S. valora a sus usuarios y está comprometida a
      salvaguardar su confidencialidad. En el desempeño de dicho compromiso, TRAVEL
      MOUSTACHE S.A.S. ha desarrollado esta <strong>"Declaración de Confidencialidad"</strong>, que
      describe las políticas y prácticas de TRAVEL MOUSTACHE S.A.S. en lo que se
      refiere a la recolección y divulgación de información personal en su página web.
    </p>

    <p> <strong>Identificación y contraseña de los afiliados:</strong> Al registrarse como miembro afiliado
      o usuario, TRAVEL MOUSTACHE S.A.S. le requiere elegir una identificación de
      usuario y una contraseña. Si Ud. pierde el control de su contraseña puede perder el
      control de su información personal y podría estar sujeto a transacciones legalmente
      válidas llevadas a cabo en su nombre. Por lo tanto, si por cualquier razón su
      contraseña llega a estar comprometida, Ud. debe de inmediato (1) cambiarla,
      modificando su información de registro que fue entregada a esta página, y (2)
      contactarnos
    </p>

    <p> <strong>Información de registro:</strong> Al registrase como miembro afiliado o usuario, TRAVEL
      MOUSTACHE S.A.S. le requiere llenar un formato de registro en el cual se especifican
      su nombre, dirección y número de calle, país, número de teléfono, dirección de correo
      electrónico y otra información. Utilizamos esta información de registro para asistirnos
      en llevar a cabo las transacciones que Ud. haya iniciado, hacer reservaciones,
      contactarlo para servicio al cliente, mejorar nuestras ofertas y servicios, y recolectar
      estadísticas sobre nuestros afiliados. Usaremos estas estadísticas para clasificar
      nuestros afiliados, por ejemplo, por país de residencia, y para enviarles nuevos
      servicios y promociones. Podemos utilizar su dirección de correo electrónico para
      contactarlo en relación con dichos nuevos servicios y promociones o para enviarle
      cartas circulares promocionales o mensajes electrónicos, salvo que Ud. no lo desee
      (ver más adelante: política de renuncia opt. out).
    </p>
  </div>

</div>
